import { render, staticRenderFns } from "./ConfigDefectsList.vue?vue&type=template&id=418691f3&scoped=true&"
import script from "./ConfigDefectsList.vue?vue&type=script&lang=js&"
export * from "./ConfigDefectsList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDefectsList.vue?vue&type=style&index=0&id=418691f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418691f3",
  null
  
)

export default component.exports